<app-dialog-confirm></app-dialog-confirm>

<section
  style="
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  "
>
  <p-splitter
    [panelSizes]="mainPanelSizes"
    [minSizes]="[40, 15]"
    [style]="{ height: '100%' }"
    (onResizeEnd)="onMainSplitterResizeEnd($event)"
  >
    <ng-template pTemplate>
      <section
        style="
          overflow: hidden;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
        "
      >
        @if (user) {
          <section style="height: 100%; display: flex; flex-direction: column">
            <div class="float-right hidden-lg hidden-xl">
              <span
                (click)="displayRightSidebar = !displayRightSidebar"
                #sidebarBtn
                ><i class="fas fa-angle-double-right"></i
              ></span>
            </div>
            <app-events
              style="flex: 1 1 auto; min-height: 0"
              [userId]="user.id"
              [eventDate]="selectedDate"
              (rowSelected)="selectEvent($event)"
            ></app-events>
          </section>
        }
      </section>
    </ng-template>

    <ng-template pTemplate>
      <section
        class="right-navi hidden-xs hidden-sm hidden-md"
        style="width: 100%; height: 100%; overflow: auto; padding-left: 0.75rem"
      >
        @switch (rightNavi) {
          @case ('calendar') {
            <ng-container [ngTemplateOutlet]="calendarView"></ng-container>
          }
          @case ('event') {
            <ng-container [ngTemplateOutlet]="eventView"></ng-container>
          }
          @default {
            <ng-container [ngTemplateOutlet]="calendarView"></ng-container>
          }
        }
      </section>
    </ng-template>
  </p-splitter>

  <p-drawer
    [(visible)]="displayRightSidebar"
    styleClass="p-drawer-lg"
    position="right"
    [baseZIndex]="10000"
  >
    @switch (rightNavi) {
      @case ('calendar') {
        <ng-container [ngTemplateOutlet]="calendarView"></ng-container>
      }
      @case ('event') {
        <ng-container [ngTemplateOutlet]="eventView"></ng-container>
      }
      @default {
        <ng-container [ngTemplateOutlet]="calendarView"></ng-container>
      }
    }
  </p-drawer>
</section>

<ng-template #calendarView>
  <section>
    <div class="p-m-2">
      <button
        pButton
        type="button"
        [routerLink]="['/schedule']"
        icon="pi pi-plus"
        iconPos="left"
        class="p-button-outlined mr-2"
        [label]="'common.button.add-booking' | translate"
      ></button>
    </div>
  </section>
  <p-datepicker [inline]="true" (onSelect)="setDate($event)"></p-datepicker>
  <app-recent-customers></app-recent-customers>
</ng-template>

<ng-template #eventView>
  @if (customer) {
    <section>
      <app-add-button
        [button]="startEventBtn"
        (buttonClick)="startEvent()"
      ></app-add-button>

      <app-customer [customer]="customer"></app-customer>
    </section>
  }

  <app-event [event]="selectedEvent" [roomSettings]="roomSettings"></app-event>
</ng-template>
